import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

function SelectTeacherDialog({ onClose, onOK, open, teachers,  }) {
  const [_selectedTeacher, setSelectedTeacher] = React.useState(null);


  const handleClose = () => {
    onClose();
  };

  const handleOK = () => {
    onOK(_selectedTeacher);
  };

  const handleSelect = (value) => {
    setSelectedTeacher(value);
  }

  return (
    <Dialog
    PaperProps={{
      sx: {
        maxHeight: 400
      }
    }}
      onClose={handleClose}
      open={open}
      fullScreen={true}
    >
      <DialogTitle>
        Select Teacher
      </DialogTitle>

      <DialogContent>
        <InputLabel>Select Teacher</InputLabel>
        <Select options={teachers} onChange={handleSelect} isMulti={false} />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleOK}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SelectTeacherDialog;
